import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProgressBarService } from '@common/services/progress-bar.service';
import { SKIP_PROGRESS_BAR } from './skip-progress-bar.token';
import { defer, finalize } from 'rxjs';

export const progressBarInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_PROGRESS_BAR)) return next(req);

  const progressBarService = inject(ProgressBarService);

  return defer(() => {
    progressBarService.requestStarted();
    return next(req).pipe(finalize(() => progressBarService.requestFinished()));
  });
};
